import {
  CapacityUnit,
  DspRateConfig,
  RateOrderType,
  RateType,
} from "@web-app/types";
import http from "@web-app/utils/http";

export type UpsertRateRowPayload = {
  amount: number;
  currency: string;
  id?: string;
  orderTypes: RateOrderType[];
  stateIds: string[];
  type: RateType;
};

export type UpsertRateConfigPayload = {
  capacity: number | null;
  capacityUnit: CapacityUnit;
  isActive: boolean;
  rates: UpsertRateRowPayload[];
};

export const listRateConfigs = () =>
  http.get<DspRateConfig[]>("/rate-configs").then((response) => response.data);

export const upsertRateConfig = (
  connectedWorkspaceId: string,
  payload: UpsertRateConfigPayload,
) =>
  http
    .put<DspRateConfig>(`/rate-configs/${connectedWorkspaceId}`, payload)
    .then((response) => response.data);
